import { useEffect, useState } from 'react';
import Modal from '../components/Modal';
import HeaderDetail from '../components/HeaderDetail'
import DataGrid from 'react-data-grid'
import { groupBy as rowGrouper } from 'lodash';

import {
  getRemotePicklistById,
  getMovementsById
} from '../states/PicklistAction'
import { PicklistItemRecordTotalColumn } from '../constants/Column'
import { DgtPdOrderPicklist, DgtPdOrderPicklistMovement } from '../models';

export default function PicklistDetailModal({ orderId, onHide } : {
  orderId: string,
  onHide: () => void
}) {
  const [ picklist, setPicklist ] = useState<DgtPdOrderPicklist>()
  const [ movements, setMovements ] = useState<DgtPdOrderPicklistMovement[]>([])
  const [expandedGroupIds, setExpandedGroupIds] = useState<ReadonlySet<unknown>>(
    () => new Set<unknown>([''])
  );

  useEffect(() => {
    const fetchPicklistsAndMovements = async (id: string) => {
      const { header } = await getRemotePicklistById(id!)
      setPicklist(header)
      
      const mvs = await getMovementsById(id)
      setMovements(mvs)
    }
    if (orderId) fetchPicklistsAndMovements(orderId)
  }, [ orderId ])

  useEffect(() => {
    if (movements.length > 0) {
      setExpandedGroupIds(new Set(movements
        .filter(mv => movements.filter(
          mv1 => mv1.materialCode === mv.materialCode).length > 1 || mv.returnGoodQty! > 0 || mv.returnWasteQty! > 0
        )
        .map(itm => itm.materialCode)
        ))
    }
  }, [ movements ])

  return <Modal
    title={`รายละเอียดใบเบิกของ PD - ${orderId}`}
    show={orderId !== ''}
    onHide={onHide}
    maxWidth={'max-w-8xl'}
    cancelText={'ปิด'}
    cancelAction={onHide}
    >
    <div className='space-y-2 '>
      <HeaderDetail title={``} header={picklist} />
      <DataGrid
        style={{ height: "100%", contain: "none" }}
        columns={PicklistItemRecordTotalColumn}
        rows={movements}
        rowKeyGetter={(row) => row.id}
        groupBy={['materialCode']}
        rowGrouper={rowGrouper}
        expandedGroupIds={expandedGroupIds}
        onExpandedGroupIdsChange={setExpandedGroupIds}
        defaultColumnOptions={{ resizable: true }}
      />
    </div>
  </Modal>
}